import React from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from '../../../../../components/Common/DateRangePicker';

const FILTER_OPTIONS = [
    { key: "TODAY", label: "Hoje" },
    { key: "WEEK", label: "Semana" },
    { key: "MONTH", label: "Mês" },
    { key: "ALL", label: "Tudo" },
];

/**
 * Renderiza o Header da aba e os controles de filtro (botoes e custom range)
 */
const AttendanceFilters = ({
    filter,
    customRange,
    handleFilterChange,
    handleCustomRange
}) => {
    // Valores de data p/ DateRangePicker (converte string YYYY-MM-DD para Date local)
    const customStartDate = customRange?.startDate ? new Date(customRange.startDate + "T00:00:00") : null;
    const customEndDate = customRange?.endDate ? new Date(customRange.endDate + "T00:00:00") : null;

    return (
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mb-4">
            <div className="d-flex align-items-center">
                <div className="avatar-sm me-3 flex-shrink-0">
                    <span className="avatar-title bg-light text-dark rounded-circle font-size-22">
                        <i className="mdi mdi-calendar-check text-muted"></i>
                    </span>
                </div>
                <div>
                    <h5 className="mb-1 fw-bold text-dark">Histórico de Frequência</h5>
                    <p className="text-muted mb-0 font-size-13">Registro detalhado de presenças e ausências do aluno.</p>
                </div>
            </div>

            <div className="d-flex align-items-center gap-2 flex-wrap">
                <div className="btn-group" role="group">
                    {FILTER_OPTIONS.map((opt) => {
                        const isActive = filter === opt.key;
                        // Usa estilos globais do Bootstrap/projeto, evitando inline overrides pesados
                        return (
                            <button
                                key={opt.key}
                                type="button"
                                className={`btn btn-sm rounded-0 ${isActive ? 'btn-primary' : 'btn-light text-muted'} fw-medium px-3`}
                                onClick={() => handleFilterChange(opt.key)}
                            >
                                {opt.label}
                            </button>
                        );
                    })}
                </div>

                <DateRangePicker
                    startDate={customStartDate}
                    endDate={customEndDate}
                    onChange={handleCustomRange}
                />
            </div>
        </div>
    );
};

AttendanceFilters.propTypes = {
    filter: PropTypes.string.isRequired,
    customRange: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }).isRequired,
    handleFilterChange: PropTypes.func.isRequired,
    handleCustomRange: PropTypes.func.isRequired
};

export default AttendanceFilters;
